export const getServerSideLocalStorage = () => ({
  getItem(key: string) {},
  setItem(key: string) {},
  removeItem(key: string) {},
});
